import { IonButtons, IonHeader, IonIcon, IonMenuButton, IonPage, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import React, { useState, useRef, useEffect } from 'react';
import LanguageSelector from '@/components/LanguageSelector';

import backend from '@/controllers/backend'

import Lesson from './Lesson';
import { Link } from 'react-router-dom';
import { caretBackOutline, caretForwardOutline, caretUpOutline } from 'ionicons/icons';
import slug from '@/controllers/slug';

const LessonPage: React.FC = () => {
  const { doc_id, doc_name, chapter_lesson_id } = useParams();

  const [chapter_id, lesson_id] = chapter_lesson_id.split("_")

  const started = useRef(false);
  const [lesson, setLesson] = useState<{title: string, opener: string, prompt: string, learning_objectives: string[], loaded: boolean}>({title: "Loading...", opener: "Loading...", prompt: "", learning_objectives: [], loaded: false})

  // nav
  const [prevLesson, setPrevLesson] = useState(null);
  const [nextLesson, setNextLesson] = useState(null);

  const later = async () => {
    // start by checking if doc_id is in the old format, and if so, forward
    if (!doc_id.match(/^\d+$/)) {
        const doc = await backend.fetch_legacy_doc(doc_id, doc_name)
        console.log(doc)
        window.location = (new URL(window.location).origin) + `/docs/${doc.id}/${doc.name}/${chapter_lesson_id}`
    }

    const chapter_lessons = await backend.chapter_lessons(doc_id, chapter_id);

    const lesson_data = chapter_lessons[lesson_id]
    lesson_data.loaded = true;
    setLesson(lesson_data)

    const nav_toc = await backend.nav_toc(doc_id)
    const cur_id = nav_toc.findIndex((x) => x.id === chapter_lesson_id)
    if (cur_id > 0) {
      setPrevLesson(nav_toc[cur_id - 1])
    }
    if (cur_id < nav_toc.length - 1) {
      setNextLesson(nav_toc[cur_id + 1])
    }
  }

  const params = useParams()
  useEffect(() => {
    document.title = lesson.title
  }, [params, lesson])

  useEffect(() => {
      if (started.current) return;
      started.current = true;

      later();
  })

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            {/* navigation icons */}
            {prevLesson && <Link to={`/docs/${doc_id}/${doc_name}/${prevLesson.id}/${slug(prevLesson.title)}`} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-zinc-800 flex items-center justify-center">
                <IonIcon icon={caretBackOutline} style={{ fontSize: '1.5rem', color: 'inherit' }} />
            </Link>}
            <Link to={`/docs/${doc_id}/${doc_name}`} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-zinc-800 flex items-center justify-center">
                <IonIcon icon={caretUpOutline} style={{ fontSize: '1.5rem', color: 'inherit' }} />
            </Link>
            {nextLesson && <Link to={`/docs/${doc_id}/${doc_name}/${nextLesson.id}/${slug(nextLesson.title)}`} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-zinc-800 flex items-center justify-center">
                <IonIcon icon={caretForwardOutline} style={{ fontSize: '1.5rem', color: 'inherit' }} />
            </Link>}
          </IonButtons>
          <IonButtons slot="end">
            <div className="pr-2">
              <LanguageSelector />
            </div>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <Lesson lesson={lesson} />
    </IonPage>
  );
};

export default LessonPage;
